import React from 'react';
export const CFIconChevronLeft = {
    alias: 'chevron-left',
    defaultTitle: 'Chevron Left',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M13.829 19a.998.998 0 0 1-.78-.372l-4.828-6a1 1 0 0 1 .01-1.268l5-6a1 1 0 1 1 1.536 1.28l-4.474 5.371 4.315 5.363a1 1 0 0 1-.78 1.627Z' }))),
};
